import { createRouter, createWebHistory } from "vue-router";
import { isAuthenticated, getUserLevel, isProjectManager } from "@/utils/auth.js"; // Import authentication middleware

// Vistas
import Dashboard from "../views/Dashboard.vue";
import Profile from "../views/Profile.vue";
//import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Time from "../views/Time.vue";
import Missing from "../views/Missing.vue";
import Projects from "../views/Projects.vue";
import TimeTable from "../views/TimeTable.vue";
import AuthRecords2 from "../views/AuthRecords2.vue";
import Deleted from "../views/Deleted.vue";
import TimeFiltered from "../views/TimeFiltered.vue";
import UsersV2 from "../views/UsersV2.vue";
import PeriodReport2 from "../views/PeriodReport2.vue";
import Repse2 from "../views/Repse2.vue";
import TimeRecords from "../views/TimeRecords.vue";
import ProjectsReport from "../views/ProjectsReport.vue";
import IncidentsUpdate from "../views/IncidentsUpdate.vue";
import AuthProjectHours from "../views/AuthProjectHours.vue";
import MyProjects from "../views/MyProjects.vue";
import Activities from "../views/Activities.vue";
import Project from "../views/Project.vue";
import NewProject from "../views/NewProject.vue";
import UnauthorizeRecords from "../views/UnauthorizeRecords.vue";
import TimeRecordsUsers from "../views/TimeRecordsUsers.vue";
import TimeRecordsByUser from "../views/TimeRecordsByUser.vue";
import UserWeekTimeRecords from "../views/UserWeekTimeRecords.vue";
import ProjectUsers from "../views/ProjectUsers.vue";
import ProjectHoursDetails from "../views/ProjectHoursDetails.vue";

// Documentación
import UserManualSignUp from "../views/Docs/UserManualSignUp.vue";
import UserManualSignIn from "../views/Docs/UserManualSignIn.vue";
import UserManualEvents from "../views/Docs/UserManualEvents.vue";
import UserManualHours from "../views/Docs/UserManualHours.vue";
import Docs from "../views/Docs/Docs.vue";

// E N   D E S A R R O L L O
//import ExternalAuth from "../views/ExternalAuth.vue";
//import AsignClientToProjects from "../views/AsignClientToProjects.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/signin",
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  /*
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },*/
  {
    path: "/home",
    name: "Inicio",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/profile",
    name: "Perfil",
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: "/calendar",
    name: "Registro de Actividades",
    component: Time,
    meta: { requiresAuth: true },
  },
  {
    path: "/users",
    name: "Usuarios",
    component: UsersV2,
    meta: { requiresAuth: true, allowedLevels: [1] },
  },
  {
    path: "/projects",
    name: "Clientes y Proyectos",
    component: Projects,
    meta: { requiresAuth: true, allowedLevels: [1, 2] },
  },
  {
    path: "/hours",
    name: "Registro de Horas",
    component: TimeTable,
    meta: { requiresAuth: true },
  },
  {
    path: "/auth-hours",
    name: "Autorización de Horas",
    component: AuthRecords2,
    meta: { requiresAuth: true, allowedLevels: [1, 2] },
  },
  {
    path: "/auth-project-hours",
    name: "Autorización de Horas de Proyectos",
    component: AuthProjectHours,
    meta: { requiresAuth: true, requiresPM: true },
  },
  {
    path: "/my-projects",
    name: "Mis Proyectos",
    component: MyProjects,
    meta: { requiresAuth: true, requiresPM: true },
  },
  {
    path: "/billable-hours-report",
    name: "Reporte de Horas Facturables",
    component: TimeFiltered,
    meta: { requiresAuth: true, allowedLevels: [1, 2] },
  },
  {
    path: "/period-report",
    name: "Reporte de Horas Por Periodo",
    component: PeriodReport2,
    meta: { requiresAuth: true, allowedLevels: [1, 2, 4] },
  },
  {
    path: "/deleted-records",
    name: "Registros Eliminados",
    component: Deleted,
    meta: { requiresAuth: true, allowedLevels: [1] },
  },
  {
    path: "/unauthorize",
    name: "Desautorizar Registros",
    component: UnauthorizeRecords,
    meta: { requiresAuth: true, allowedLevels: [1] },
  },
  {
    path: "/time-records",
    name: "Registros De Tiempo",
    component: TimeRecords,
    meta: { requiresAuth: true, allowedLevels: [1, 2] },
  },
  {
    path: "/project-hour-report",
    name: "Horas Por Proyecto",
    component: ProjectsReport,
    meta: { requiresAuth: true, allowedLevels: [1, 2] },
  },
  {
    path: "/repse-report",
    name: "Reporte de REPSE",
    component: Repse2,
    meta: { requiresAuth: true, allowedLevels: [1, 2, 4] },
  },
  {
    path: "/factorial-incidents",
    name: "Incidencias de Factorial",
    component: IncidentsUpdate,
    meta: { requiresAuth: true, allowedLevels: [1] },
  },
  {
    path: "/activities",
    name: "Actividades",
    component: Activities,
    meta: { requiresAuth: true, allowedLevels: [1] },
  },
  {
    path: "/time-records-users",
    name: "Registros de Tiempo por Usuarios",
    component: TimeRecordsUsers,
    meta: { requiresAuth: true, allowedLevels: [1] },
  },
  {
    path: "/user-time-records/:id",
    name: "Registros de Tiempo del Usuario",
    component: TimeRecordsByUser,
    props: true,
    meta: { requiresAuth: true, allowedLevels: [1] },
  },
  {
    path: "/project/:id",
    name: "Proyecto",
    component: Project,
    props: true,
    meta: { requiresAuth: true, allowedLevels: [1, 2] },
  },
  {
    path: "/new-project",
    name: "Nuevo Proyecto",
    component: NewProject,
    props: true,
    meta: { requiresAuth: true, allowedLevels: [1, 2] },
  },
  {
    path: "/project-users/:id",
    name: "Colaboradores del Proyecto",
    component: ProjectUsers,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/auth-user-hours",
    name: "Autorizar Colaborador",
    component: UserWeekTimeRecords,
    props: true,
    meta: { requiresAuth: true, allowedLevels: [1, 2] },
  },
    
  {
    path: "/project-hours-details",
    name: "Detalles de Horas en Proyecto",
    component: ProjectHoursDetails,
    props: true,
    meta: { requiresAuth: true },
  },
  /*
  {
    path: "/assign-client-to-projects",
    name: "Revisar Clientes",
    component: AsignClientToProjects,
    meta: { requiresAuth: true, allowedLevels: [1] },
  },*/
  /*
  {
    path: "/external-auth",
    name: "Autorizar Registros (Externo)",
    component: ExternalAuth,
    props: true,
    meta: { requiresAuth: true, allowedLevels: [1, 7] },
  },*/
  {
    path: "/documentation",
    name: "Documentación",
    component: Docs,
  },
  {
    path: "/user-manual",
    name: "Manual de Usuario",
    component: UserManualSignUp,
  },
  {
    path: "/user-manual-signup",
    name: "Manual de Usuario - Registro de Cuenta",
    component: UserManualSignUp,
  },
  {
    path: "/user-manual-signin",
    name: "Manual de Usuario - Inicio de Sesión",
    component: UserManualSignIn,
  },
  {
    path: "/user-manual-events",
    name: "Manual de Usuario - Registro de Eventos",
    component: UserManualEvents,
  },
  {
    path: "/user-manual-hours",
    name: "Manual de Usuario - Registro de Horas",
    component: UserManualHours,
  },
  {
    path: "/:pathMatch(.*)*",// In case a path is invalid redirect to missing page
    name: "No Encontrado",
    component: Missing,
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Global Navigation Guard
router.beforeEach((to, from, next) => {
  const user = isAuthenticated();
  const userLevel = getUserLevel();

  if (to.meta.requiresAuth && !user) {
    next({ name: "Signin" }); // If is not authenticated redirect to login
  } else if (to.name === "Signin" && user) {
    next({ name: "Inicio" }); // If is authenticated and tries to login, redirect to home page
  } else if (to.meta.allowedLevels && !to.meta.allowedLevels.includes(userLevel)) {
    next({ name: "Inicio" }); // If level is not in allowedLevels array, redirect to home page
  } else if (to.meta.requiresPM && !isProjectManager()) {
    next({ name: "Inicio" }); // If route requires being a PM and the user is not, redirect to home page
  } else {
    next(); // Allow page navigation
  }
});

export default router;
